<template>
  <div>
    <BaseFrame>
      <div slot="content" class="con">
        <lk-card title="结算信息" style="margin-top: 20px">
          <div class="cardInfoCon">
            <div v-for="(item, index) in settleInfo" :key="index" class="everyInfo">
              {{`${item.title} : ${settleInfoObj[item.key] ? settleInfoObj[item.key] : ""}`}}
            </div>
          </div>
        </lk-card>
        <lk-card title="基金分项信息" style="margin-top: 20px">
          <div>
            <lk-table border :columns="columns" :data="tableData"></lk-table>
          </div>
        </lk-card>
        <lk-card title="费用明细" style="margin-top: 20px">
          <div>
            <lk-table border :columns="columnsDetail" :data="tableDataDetail"></lk-table>
          </div>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import utils from "../../libs/utils";
import BaseFrame from "../../components/frame/BaseFrame.vue";
import healthInsManage from "../../services/healthInsManage";

export default {
  name: "settleInfo",
  components: { BaseFrame },
  data() {
    return {
      settleInfo: [
        {
          title: "结算id",
          key: "setlId",
        },
        {
          title: "就诊id",
          key: "mdtrtId",
        },
        {
          title: "人员编号",
          key: "psnNo",
        },
        {
          title: "人员姓名",
          key: "psnName",
        },
        {
          title: "证件类型",
          key: "psnCertTypeName",
        },
        {
          title: "证件号码",
          key: "certno",
        },
        {
          title: "性别",
          key: "gend",
        },
        {
          title: "民族",
          key: "naty",
        },
        {
          title: "出生日期",
          key: "brdy",
        },
        {
          title: "年龄",
          key: "age",
        },
        {
          title: "险种类型",
          key: "insutype",
        },
        {
          title: "人员类别",
          key: "psnType",
        },
        {
          title: "参保机构医保区划",
          key: "insuOptins",
        },
        {
          title: "结算时间",
          key: "setlTime",
        },
        {
          title: "医疗类别",
          key: "medType",
        },
        {
          title: "医疗费总额",
          key: "medfeeSumamt",
        },
        {
          title: "全自费金额",
          key: "fulamtOwnpayAmt",
        },
        {
          title: "超限价自费金额",
          key: "overlmtSelfpay",
        },
        {
          title: "先行自付金额",
          key: "preselfpayAmt",
        },
        {
          title: "符合政策范围金额",
          key: "inscpScpAmt",
        },
        {
          title: "实际支付起付线",
          key: "actPayDedc",
        },
        {
          title: "基本医疗保险统筹基金支出",
          key: "hifpPay",
        },
        {
          title: "基本医疗保险统筹基金支付比例",
          key: "poolPropSelfpay",
        },
        {
          title: "公务员医疗补助资金支出",
          key: "cvlservPay",
        },
        {
          title: "企业补充医疗保险基金支出",
          key: "hifesPay",
        },
        {
          title: "居民大病医疗费用补助基金支出",
          key: "hifmiPay",
        },
        {
          title: "医疗救助基金支出",
          key: "mafPay",
        },
        {
          title: "其他支出",
          key: "othPay",
        },
        {
          title: "基金支付总额",
          key: "fundPaySumamt",
        },
        {
          title: "个人支付总金额",
          key: "psnPay",
        },
        {
          title: "个人账户支出",
          key: "acctPay",
        },
        {
          title: "个人现金支出",
          key: "cashPayamt",
        },
        {
          title: "余额",
          key: "balc",
        },
        {
          title: "个人帐户共济支付金额",
          key: "acctMulaidPay",
        },
        {
          title: "医药机构结算id",
          key: "medinsSetlId",
        },
        {
          title: "退费结算标志",
          key: "refdSetlFlag",
        },
        {
          title: "清算经办机构",
          key: "clrOptins",
        },
        {
          title: "清算方式",
          key: "clrWayName",
        },
        {
          title: "清算类别",
          key: "clrTypeName",
        },
        {
          title: "年度",
          key: "year",
        },
        {
          title: "病种编码",
          key: "diseCodg",
        },
      ],
      settleInfoObj: {},
      columns: [
        {
          type: 'index',
          title: '序号',
          width: 60,
        },
        {
          title: '基金支付类型',
          key: 'fundPayTypeName',
          minWidth: 140,
        },
        {
          title: '符合政策范围金额',
          key: 'inscpScpAmt',
          minWidth: 140,
        },
        {
          title: '本次可支付限额金额',
          key: 'crtPaybLmtAmt',
          minWidth: 140,
        },
        {
          title: '基金支付金额',
          key: 'fundPayamt',
          minWidth: 140,
        },
        {
          title: '过程结算信息',
          key: 'setlProcInfo',
          minWidth: 140,
        },
      ],
      tableData: [],
      columnsDetail: [ // 费用信息列表
        {
          type: 'index',
          title: '序号',
          width: 60,
        },
        {
          title: '就诊id',
          key: 'mdtrtId',
          minWidth: 140,
        },
        {
          title: '结算id',
          key: 'setlId',
          minWidth: 140,
        },
        {
          title: '费用明细流水号',
          key: 'feedetlSn',
          minWidth: 140,
        },
        {
          title: '医保目录编码',
          key: 'hilistCode',
          minWidth: 140,
        },
        {
          title: '医疗机构目录编码',
          key: 'medinsListCodg',
          minWidth: 140,
        },
        {
          title: '医疗机构目录名称',
          key: 'medinsListName',
          minWidth: 140,
        },
        {
          title: '医疗收费项目类别',
          key: 'medChrgitmType',
          minWidth: 140,
        },
        {
          title: '医疗类别',
          key: 'medTypeName',
          minWidth: 140,
        },
        {
          title: '收费项目等级',
          key: 'chrgitmLvName',
          minWidth: 140,
        },
        {
          title: '费用发生时间',
          key: 'feeOcurTime',
          minWidth: 140,
        },
        {
          title: '数量',
          key: 'cnt',
          minWidth: 140,
        },
        {
          title: '单价',
          key: 'pric',
          minWidth: 140,
        },
        {
          title: '明细项目费用总额',
          key: 'detItemFeeSumamt',
          minWidth: 140,
        },
        {
          title: '定价上限金额',
          key: 'pricUplmtAmt',
          minWidth: 140,
        },
        {
          title: '自付比例',
          key: 'selfpayProp',
          minWidth: 140,
        },
        {
          title: '全自费金额',
          key: 'fulamtOwnpayAmt',
          minWidth: 140,
        },
        {
          title: '超限价金额',
          key: 'overlmtAmt',
          minWidth: 140,
        },
        {
          title: '先行自付金额',
          key: 'preselfpayAmt',
          minWidth: 140,
        },
        {
          title: '符合政策范围金额',
          key: 'inscpScpAmt',
          minWidth: 140,
        },
        {
          title: '经办人',
          key: 'opterName',
          minWidth: 140,
        },
        {
          title: '经办时间',
          key: 'optTime',
          minWidth: 140,
        },
      ],
      tableDataDetail: [],// 费用信息数据
    };
  },
  methods: {
    getExpenseInfo(params) {
      healthInsManage.getExpenseInfo(params).then((res) => {
        if (res.data.status === 200) {
          this.settleInfoObj = res.data.data.setlinfo;
          this.tableData = res.data.data.setldetail;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      })
    },
    getExpenseInfoDetail(params) {
      healthInsManage.getExpenseInfoDetail(params).then((res) => {
        if (res.data.status === 200) {
          this.tableDataDetail = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      })
    }
  },
  mounted() {
    this.getExpenseInfo(this.$route.query);
    this.getExpenseInfoDetail(this.$route.query);
  },
};
</script>
<style lang="less" scoped>
.con {
  width: 98%;
  background-color: #ffffff;
  padding: 30px;
  .everyInfo {
    width: 32%;
    display: inline-block;
    margin-top: 10px;
  }
}
</style>